import { get, post } from './http'

/** 可领取优惠券列表（活动页展示用） */
export function fetchCoupons(token) {
  return get('/coupon', {}, { token })
}

/** 新用户首单优惠领取 */
export function claimFirstCoupon(token) {
  return post('/coupon/first', {}, { token })
}

/**
 * 邀请好友领取课程优惠券
 * @param {string} code 用户输入的邀请码
 */
export function claimInviteCoupon(code, token) {
  return post('/coupon/invite', { code }, { token })
}

/** 当前用户资料（含 referral_code） */
export function fetchProfile(token) {
  return get('/portal/profile', {}, { token })
}
